/**
 *
 *
 *
 *
 *
 */
export class RequestError extends Error {
  /**
 *
 */
  name = "RequestError" as const;

  /**
 *
 */
  response: Response;

  /**
 *
 *
 *
 *
 *
 */
  constructor(message: string, response: Response, options?: { cause?: unknown }) {
    super(message, options);
    this.response = response;
  }
}
